import bg from '@propertypal/shared/src/resources/bg/crawfords-farm-header.png';
import Link from 'next/link';
import styled from 'styled-components';
import { Container as Button } from '../../buttons/Button.style';
import { Heading, Text } from '../../typography';

export const Container = styled.div`
  background-image: url(${bg.src});
  height: 672px;
  position: relative;
  background-size: cover;
  background-position: center center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  border-radius: 5px;

  &::before {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    content: '';
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;

export const Block = styled.div`
  background-color: rgb(69, 100, 128);
  padding: 16px;
  position: absolute;
  max-width: 300px;
  z-index: 3;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  text-align: center;

  ${Text} {
    color: ${({ theme }) => theme.white};
  }

  @media (min-width: 768px) {
    bottom: 0;
    right: 0;
    left: auto;
    top: auto;
    margin: initial;
    max-width: 320px;
    text-align: left;
    padding: 24px;
  }
`;

export const Content = styled.div`
  z-index: 2;
  margin-bottom: 16px;
  padding: 0 10px;

  ${Text}, ${Heading} {
    color: ${({ theme }) => theme.white};
    text-align: center;
  }

  ${Text} {
    font-size: 17px;
  }
`;

export const ButtonLink = styled(Link)`
  z-index: 2;
  padding: 0 10px;
  width: 100%;

  ${Button} {
    font-size: 17px;
    width: 100%;
    margin: 0 auto;
  }
`;
